export default __webpack_public_path__ + "static/media/no-prospect-task.865b379b.svg";